// extracted by mini-css-extract-plugin
export default {"root":"DraftInvoicesTable_root__ymthc","header-wrapper":"DraftInvoicesTable_header-wrapper__uoo9f","datepicker-wrapper":"DraftInvoicesTable_datepicker-wrapper__emj-c"};